import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-product-configuration',
    templateUrl: './product-configuration.component.html',
    styleUrls: ['./product-configuration.component.scss'],
    standalone: false
})
export class ProductConfigurationComponent implements OnInit {

  navLinks: any[];
  activeLinkIndex = -1;
activeTab: 'intake' | 'scheduler' = 'intake';
  isSidenavOpen=false;
  selectedProductDetails:any=null;
  constructor(private router: Router) {
    this.navLinks = [
      {
        label: 'Product Safety Strategy Templates',
        link: './jsip-productsafetystrategytemplate',
        index: 0
      },
      {
        label: 'Activity Configuration',
        link: './jsip-reviewActivityConfig',
        index: 1
      },
      {
        label: 'Role Product Group Mapping',
        link: './jsip-productAccess',
        index: 2
      },
      {
        label: 'Product Group Product Mapping',
        link: './jsip-productMapping',
        index: 3
      }
    ];
   }

  ngOnInit(): void {
      this.router.events.subscribe((res) => {
      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.link === '.' + this.router.url));
    });
  }
}
